import React from 'react'
import {Dimmer, Loader} from 'semantic-ui-react';
import Layout from "../features/nav/Layout";

import 'semantic-ui-css/components/dimmer.min.css'
import 'semantic-ui-css/components/loader.min.css'

const LoadingComponent = ({inverted = true}) => {
    return (
        <Layout mainContent={
            <Dimmer inverted={inverted} active={true}>
                <Loader content='Loading...'/>
            </Dimmer>
        }/>
    )
}

export default LoadingComponent
